module.exports = __webpack_public_path__ + "img/newchris-33.ed5d8ab8.jpg";